/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */
import React from "react";
import PropTypes, { bool } from "prop-types";
import ScrollerThumb from "./ScrollerThumb";
import { func } from "prop-types";

const Scroller = (props) => {
  const { elRef, onMouseDown, onTouchStart, onMouseUp, onTouchEnd, active } =
    props;
  return (
    <div
      ref={elRef}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
      className={active ? "scroller  scrolling" : "scroller"}
      draggable
    >
      <ScrollerThumb />
    </div>
  );
};

Scroller.propTypes = {
  elRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onMouseDown: func,
  onTouchStart: func,
  onMouseUp: func,
  onTouchEnd: func,
  active: bool,
};

export default Scroller;
